var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "选择优惠券",
        width: "1000px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
        drag: _vm.drag,
        modal: false,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "btnview" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.addCoupon },
            },
            [_vm._v("添加优惠券")]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn_primary",
              attrs: { size: "small" },
              on: { click: _vm.anhandleRecord },
            },
            [_vm._v("领券记录")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "sendCoupon overflowOuto",
        },
        [
          _c(
            "div",
            { staticClass: "couponList" },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "couponCard",
                  class: `status${item.status}`,
                  on: {
                    click: function ($event) {
                      return _vm.selectFn(item)
                    },
                  },
                },
                [
                  _c("div", {
                    class: [0].includes(item.status) ? "bg2" : "bg1",
                  }),
                  _vm.selectCoupon &&
                  item.couponNo === _vm.selectCoupon.couponNo
                    ? _c("img", {
                        staticClass: "selectIcon",
                        attrs: {
                          src: require("@/assets/image/coupon/selectIcon.png"),
                        },
                      })
                    : _vm._e(),
                  _vm.selectCoupon &&
                  item.couponNo === _vm.selectCoupon.couponNo
                    ? _c("div", { staticClass: "selectBox" })
                    : _vm._e(),
                  _c("div", { staticClass: "couponView" }, [
                    _c(
                      "div",
                      { staticClass: "leftMoney" },
                      [
                        item.discountMethod === 1
                          ? [
                              _c("div", { staticClass: "couponMoney" }, [
                                _c(
                                  "div",
                                  { staticClass: "couponFullReduction" },
                                  [
                                    _c("span", { staticClass: "couponUnit" }, [
                                      _vm._v("￥"),
                                    ]),
                                    _c("span", { staticClass: "couponMoney" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("filtersMoneyByZeroNoSplit")(
                                            item.subtractAmount
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("div", { staticClass: "couponTips" }, [
                                  _vm._v(
                                    "满" +
                                      _vm._s(
                                        _vm._f("filtersMoneyByZeroNoSplit")(
                                          item.satisfiedAmount
                                        )
                                      ) +
                                      "元减" +
                                      _vm._s(
                                        _vm._f("filtersMoneyByZeroNoSplit")(
                                          item.subtractAmount
                                        )
                                      ) +
                                      "元"
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "couponTypeText" }, [
                                _vm._v("满减券"),
                              ]),
                            ]
                          : item.discountMethod === 2
                          ? [
                              _c("div", { staticClass: "couponMoney" }, [
                                _c(
                                  "div",
                                  { staticClass: "couponFullReduction" },
                                  [
                                    _c("span", { staticClass: "couponUnit" }, [
                                      _vm._v("￥"),
                                    ]),
                                    _c("span", { staticClass: "couponMoney" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("filtersMoneyByZero")(
                                            item.directReductionAmount
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "couponTypeText" }, [
                                _vm._v("直减券"),
                              ]),
                            ]
                          : item.discountMethod === 3
                          ? [
                              _c("div", { staticClass: "couponMoney" }, [
                                _c(
                                  "div",
                                  { staticClass: "couponFullReduction" },
                                  [
                                    _c("span", { staticClass: "couponMoney" }, [
                                      _vm._v(_vm._s(item.sale)),
                                    ]),
                                    _c("span", { staticClass: "couponUnit" }, [
                                      _vm._v("折"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "couponTypeText" }, [
                                _vm._v("折扣券"),
                              ]),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "couponContent" }, [
                      _c(
                        "div",
                        { staticClass: "couponContentName" },
                        [
                          _c("textShowMore", {
                            key: index,
                            staticStyle: { width: "274px" },
                            attrs: {
                              text: `${item.couponName}(${item.couponNo})`,
                              "line-clamp": 1,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "couponContentTips" }, [
                        _vm._v("券有效时间"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "couponContentTime" },
                        [
                          item.expireDays && item.expireDays > 0
                            ? [
                                _vm._v(
                                  " 自领取之日" +
                                    _vm._s(item.expireDays) +
                                    "天内有效 "
                                ),
                              ]
                            : [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("parseTime")(item.useStartTime)
                                    ) +
                                    "~" +
                                    _vm._s(
                                      _vm._f("parseTime")(item.useEndTime)
                                    ) +
                                    " "
                                ),
                              ],
                        ],
                        2
                      ),
                      _c("div", { staticClass: "couponContentTips m-t-8" }, [
                        _vm._v("券领取时间"),
                      ]),
                      _c("div", { staticClass: "couponContentTime" }, [
                        _vm._v(
                          _vm._s(_vm._f("parseTime")(item.claimStartTime)) +
                            "~" +
                            _vm._s(_vm._f("parseTime")(item.claimEndTime))
                        ),
                      ]),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm.list.length === 0
            ? _c("div", { staticClass: "noData" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/image/zanwusousuoneirong2.png"),
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "noDataText" }, [_vm._v("暂无数据")]),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "ss-material-box-bottom",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "w-100p" },
            [
              _vm.showRevoke
                ? _c("span", { staticStyle: { "margin-right": "16px" } }, [
                    _vm._v("停留时间"),
                  ])
                : _vm._e(),
              _vm.showRevoke
                ? _c(
                    "el-input",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "请输入", size: "small" },
                      on: { input: _vm.delNumber },
                      model: {
                        value: _vm.stayTime,
                        callback: function ($$v) {
                          _vm.stayTime = $$v
                        },
                        expression: "stayTime",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append", size: "small" },
                          slot: "append",
                        },
                        [_vm._v("分钟")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "btnView m-l-10" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.onhandleSend },
                    },
                    [_vm._v("发送")]
                  ),
                  _vm.showRevoke
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", loading: _vm.loading },
                          on: { click: _vm.onhandleRevoke },
                        },
                        [_vm._v("撤回")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "cancelBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }